package components.routing

import pages.login.LoginPage
import react.FC
import react.create
import react.router.Route
import react.router.Routes

val UnprotectedRouting = FC<UnprotectedRoutingProps>("UnprotectedRouting") {props ->
    Routes {
        // page without url param
        Route {
            index = true
            element = LoginPage.create {
                getCompanyFromUrl = false
                sessionSetter = props.sessionSetter
                darkMode = props.darkMode
            }
        }

        // page without url param
        Route {
            path = ApplicationRoutingUrls.Unprotected.withOwner
            element = LoginPage.create {
                getCompanyFromUrl = true
                sessionSetter = props.sessionSetter
                darkMode = props.darkMode
            }
        }
    }
}